export const PinInputStyles = {
  variants: {
    base: {
      borderRadius: "base",
      border: "base",
      borderColor: "input_border_color_primary",
      _focus: {
        borderColor: "input_border_focus_color_primary",
      },
    },
  },
  defaultProps: {
    variant: "base",
  },
}
